import { StatusTracking } from '../../../types/statusTrackingTypes'
import statusTrackingService from './statusTrackingService'

const buscarStatusTracking = async (): Promise<StatusTracking[]> => statusTrackingService.buscarStatusTracking()

export default {
  buscarStatusTracking
}
